export default __webpack_public_path__ + "static/media/IMG0710.5af98132.jpg";